import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import StatusIcon from '../../../components/common/statusIcon';
import Utils from '../../../script/utils';
import * as homeActions from '../../../actions/home_action';
import * as alarmActions from '../../../actions/alarm_action';
import * as equipmentActions from '../../../actions/equipment_action';
import * as deviceMonitorActions from '../../../actions/deviceMonitor_action';
import * as deviceMonitorTreeActions from '../../../actions/deviceMonitorTree_action';
import { Row, Col, Divider } from 'antd';
import moment from 'moment';

const levelLabels = {
  IT_AL_CRITICAL: '严重',
  IT_AL_MAJOR: '主要',
  IT_AL_MINOR: '次要',
  IT_AL_WARNING: '警告',
  IT_AL_INFO: '提示',
};

const levelIcons = {
  IT_AL_CRITICAL: 'error',
  IT_AL_MAJOR: 'error',
  IT_AL_MINOR: 'warning',
  IT_AL_WARNING: 'warning',
  IT_AL_INFO: 'good',
};

const statusLabels = {
  IT_AL_ACTIVE: '活动告警',
  IT_AL_CONFIRMED: '已确认',
  IT_AL_CLOSED: '已关闭',
};

class DrawerEventLogsView extends Component {
  state = {
    alarmEventLogs: [],
  };

  componentDidMount() {
    const { treeStore, alarmEventLogs } = this.props;
    if (!treeStore || treeStore.length === 0) {
      this.props.deviceMonitorTreeActions.getDeviceMonitorTreeData(null);
    }
    this.setState({
      alarmEventLogs: (alarmEventLogs || []).slice().sort((a, b) => (a.alarmLevel || '').localeCompare(b.alarmLevel || '')),
    });
  }

  componentWillReceiveProps(nextProps) {
    const { deviceMonitorTreeData, alarmEventLogs } = nextProps;
    if (deviceMonitorTreeData !== this.props.deviceMonitorTreeData) {
      const { rootArr, deviceMonitorTreeMap } = Utils.formatTreeData(deviceMonitorTreeData);
      this.props.deviceMonitorTreeActions.setDeviceMonitorTreeMap(deviceMonitorTreeMap);
      this.props.deviceMonitorTreeActions.setTreeStore(rootArr);
    }
    if (alarmEventLogs !== this.props.alarmEventLogs) {
      this.setState({
        alarmEventLogs: (alarmEventLogs || []).slice().sort((a, b) => (a.alarmLevel || '').localeCompare(b.alarmLevel || '')),
      });
    }
  }

  statusFormatter = level => <StatusIcon status={levelIcons[level] || 'warning'} />;

  renderEventLevel = record => <span>{levelLabels[record.alarmLevel] || record.alarmLevel || ''}</span>;

  renderEventStatus = record => statusLabels[record.currentStatusId] || record.currentStatusId || '';

  renderEventEquipment = record => {
    const { deviceMonitorTreeMap } = this.props;
    const equipment = deviceMonitorTreeMap && deviceMonitorTreeMap[record.equipmentId];
    const label = record.equipmentName || (equipment && (equipment.ServerAddress || equipment.name || equipment.Title)) || '';
    return equipment ? <a onClick={() => this.onEquipmentIpClick(record)}>{label}</a> : label;
  };

  renderEventGroup = record => {
    const { deviceMonitorTreeMap } = this.props;
    const equipment = deviceMonitorTreeMap && deviceMonitorTreeMap[record.equipmentId];
    const group = equipment && deviceMonitorTreeMap[equipment.GroupId || equipment.groupId || equipment.pid];
    return group ? <a onClick={() => this.onGroupNameClick(record)}>{group.GroupName || group.name}</a> : '';
  };

  renderMonitor = record => <a onClick={() => this.onMonitorNameClick(record)}>{record.monitorName || record.monitorId}</a>;

  renderMonitorValue = record => [record.metricType, record.metricValue ? `当前值=${record.metricValue}` : '', record.threshold ? `阈值=${record.threshold}` : ''].filter(Boolean).join('，');

  onGroupNameClick = record => {
    const { deviceMonitorTreeMap } = this.props;
    const equipment = deviceMonitorTreeMap && deviceMonitorTreeMap[record.equipmentId];
    const node = equipment && deviceMonitorTreeMap[equipment.GroupId || equipment.groupId || equipment.pid];
    if (!node) return;
    this.props.deviceMonitorActions.setNoRefreshMonitorViewFlag(true);
    this.props.deviceMonitorActions.setMonitorView(3);
    this.props.history.push('/');
    this.props.equipmentActions.setSelectedNode(Object.assign({}, node));
    this.props.equipmentActions.setBackupTreeNode(Object.assign({}, node));
  };

  onEquipmentIpClick = record => {
    const { deviceMonitorTreeMap } = this.props;
    const node = deviceMonitorTreeMap && deviceMonitorTreeMap[record.equipmentId];
    if (!node) return;
    this.props.deviceMonitorActions.setNoRefreshMonitorViewFlag(true);
    this.props.deviceMonitorActions.setMonitorView(4);
    this.props.history.push('/');
    const ids = (node.EquipmentMonitor || []).map(item => item.RecId || item.monitorId).filter(Boolean);
    this.props.deviceMonitorActions.getThresholdList(ids, () => {
      this.props.equipmentActions.setBackupResource(node);
      this.props.equipmentActions.setSelectedNode(node);
      this.props.equipmentActions.setSelectedClickNode(node);
      this.props.equipmentActions.setbClickTreeNode(true);
    });
  };

  onMonitorNameClick = record => {
    const { deviceMonitorTreeMap } = this.props;
    const node = deviceMonitorTreeMap && deviceMonitorTreeMap[record.monitorId];
    if (!node) return;
    this.props.deviceMonitorActions.setNoRefreshMonitorViewFlag(true);
    this.props.deviceMonitorActions.setMonitorView(5);
    this.props.history.push('/');
    this.props.deviceMonitorActions.getThresholdList([record.monitorId], () => {
      this.props.equipmentActions.setOnTreeNodeClick(true);
      this.props.equipmentActions.setSelectedNode(node);
      this.props.equipmentActions.setBackupTreeNode(node);
      this.props.equipmentActions.setSelectedClickNode(node);
      this.props.equipmentActions.setSelectedResource(Object.assign(this.props.deviceMonitorTreeMap[record.equipmentId] || {}, {}));
    });
  };

  render() {
    const { treeStore } = this.props;
    const { alarmEventLogs } = this.state;
    const content = treeStore && treeStore.length > 0 ? alarmEventLogs.map((item, index) => (
      <div key={item.eventId || index}>
        {index === 0 ? null : <Divider />}
        <Row>
          <Col span={12}>
            <span className="label-colon">级别</span>
            <span>{this.statusFormatter(item.alarmLevel)}&nbsp;{this.renderEventLevel(item)}</span>
          </Col>
          <Col span={12}>
            <span className="label-colon">状态</span>
            <span>{this.renderEventStatus(item)}</span>
          </Col>
          <Col span={12}>
            <span className="label-colon">事件组</span>
            <span>{this.renderEventGroup(item)}</span>
          </Col>
          <Col span={12}>
            <span className="label-colon">事件设备</span>
            <span>{this.renderEventEquipment(item)}</span>
          </Col>
          <Col span={12}>
            <span className="label-colon">触发时间</span>
            <span>{item.triggerTime ? moment(item.triggerTime).format('MM-DD HH:mm:ss') : ''}</span>
          </Col>
          <Col span={12}>
            <span className="label-colon">规则ID</span>
            <span>{item.ruleId}</span>
          </Col>
          <Col span={24}>
            <span className="label-colon">事件监测器</span>
            <span>{this.renderMonitor(item)}</span>
          </Col>
          <Col span={24}>
            <span className="label-colon">详细信息</span>
            <span className="detailContent">{this.renderMonitorValue(item)}</span>
          </Col>
        </Row>
      </div>
    )) : null;

    return (
      <div className="drawerView">
        <div className="drawerView-content">{content}</div>
      </div>
    );
  }
}

DrawerEventLogsView.contextTypes = {
  router: PropTypes.object,
};

const mapStateToProps = state => {
  const { deviceMonitorTreeData, deviceMonitorTreeMap, treeStore } = state.deviceMonitorTreeReducer;
  return { treeStore, deviceMonitorTreeData, deviceMonitorTreeMap };
};

const mapDispatchToProps = dispatch => ({
  homeActions: bindActionCreators(homeActions, dispatch),
  alarmActions: bindActionCreators(alarmActions, dispatch),
  equipmentActions: bindActionCreators(equipmentActions, dispatch),
  deviceMonitorActions: bindActionCreators(deviceMonitorActions, dispatch),
  deviceMonitorTreeActions: bindActionCreators(deviceMonitorTreeActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DrawerEventLogsView));
